export default __webpack_public_path__ + "static/media/40.ae77abf5.jpg";